"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * 数组并集,只支持一维数组
 * @param {Array} arrOne
 * @param {Array} arrTwo
 */
var arrAndSet = exports.arrAndSet = function arrAndSet(arrOne, arrTwo) {
  return arrOne.concat(arrTwo.filter(function (v) {
    return !arrOne.includes(v);
  }));
};
/**
 * 数组交集,只支持一维数组
 * @param {Array} arrOne
 * @param {Array} arrTwo
 */
var arrIntersection = exports.arrIntersection = function arrIntersection(arrOne, arrTwo) {
  return arrOne.filter(function (v) {
    return arrTwo.includes(v);
  });
};
/**
 * 数组差集,只支持一维数组
 * @param {Array} arrOne
 * @param {Array} arrTwo
 * eg: [1, 2, 3] [2, 4, 5] 差集为[1,3,4,5]
 */
var arrDifference = exports.arrDifference = function arrDifference(arrOne, arrTwo) {
  return arrOne.concat(arrTwo).filter(function (v) {
    return !arrOne.includes(v) || !arrTwo.includes(v);
  });
};
/**
 * 数组合并,只支持一维数组
 * @param {Array} arrOne 数组
 * @param {Array} arrTwo 数组
 */
var arrConcat = exports.arrConcat = function arrConcat(arrOne, arrTwo) {
  return [].concat(_toConsumableArray(arrOne), _toConsumableArray(arrTwo));
};
/**
 * 数组去重
 * @param {Array} arr  数组
 */
var arrRemoveRepeat = exports.arrRemoveRepeat = function arrRemoveRepeat(arr) {
  return Array.from(new Set(arr));
};
/**
 * [arrDropWhile 删除不符合条件的值]
 *
 * @param   {[array]}  arr   [arr 目标数组]
 * @param   {[function]}  func  [func description]
 *
 * @return  {[array]]}        [return 数组]
 */
var arrDropWhile = exports.arrDropWhile = function arrDropWhile(arr, func) {
  while (arr.length > 0 && !func(arr[0])) {
    arr = arr.slice(1);
  }return arr;
};

exports.default = {
  arrDifference: arrDifference,
  arrDropWhile: arrDropWhile,
  arrIntersection: arrIntersection,
  arrAndSet: arrAndSet,
  arrConcat: arrConcat,
  arrRemoveRepeat: arrRemoveRepeat
};